import CardCompanyCompetitors from "@/components/company/card-company-competitors";
import CardTalentFlow from "@/components/company/card-talent-flow";
import { FadeInSection } from "@/components/company/company-animations";
import CompanyTabReadFailed from "@/components/company/company-tab-read-failed";
import { useAreSectionsFailed } from "@/contexts/company-sections-context";
import { COMPANY_TAB_SECTIONS } from "@/lib/company-card-sections";
import { hasOthersData } from "@/lib/company-data-availability";
import { useCompanyTabContext } from "./company-tab-context";

export default function CompanyOthersPage() {
  const { company } = useCompanyTabContext();
  const isReadFailed = useAreSectionsFailed(COMPANY_TAB_SECTIONS.others);

  return (
    <FadeInSection>
      <div className="flex flex-col gap-4">
        {isReadFailed && !hasOthersData(company) && <CompanyTabReadFailed />}
        <CardTalentFlow company={company} />
        <CardCompanyCompetitors company={company} />
      </div>
    </FadeInSection>
  );
}
